"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeOfDocs = void 0;
var typeOfDocs = exports.typeOfDocs = {
  name: 'typeOf',
  category: 'Utils',
  syntax: ['typeOf(x)'],
  description: 'Get the type of a variable.',
  examples: ['typeOf(3.5)', 'typeOf(2 - 4i)', 'typeOf(45 deg)', 'typeOf("hello world")'],
  seealso: ['getMatrixDataType']
};